import { BASE_URL } from '@app/settings/base-url';
import { baseApi } from '@app/store/index.api';
import type { FetchArgs } from '@reduxjs/toolkit/query';

import { IQRCodeQuery, IQRCodeResponse } from '../model/types';

const qrApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getQRCode: builder.query<IQRCodeResponse, IQRCodeQuery>({
      query: ({ order_hash }): FetchArgs => ({
        url: `${BASE_URL}/deposit/${order_hash}/qr`,
      }),
    }),
  }),
});

export const { useLazyGetQRCodeQuery } = qrApi;
